import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth.module.js';
import menu from './modules/menu.module.js';
import pdv from './modules/pdv.module.js';
import users from './modules/users.module.js';
import socket from './modules/socket.module.js';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth, menu, pdv, users, socket
    },
    strict: false
});
